import { useMutation, useQueryClient } from '@tanstack/react-query';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../constants/queryKeys';
import useToastMsg from '../../common/useToastMsg';
import categoryToastMsg from '../../../constants/service/toastMsg/categoryToastMsg';
import { useLocation } from 'react-router-dom';

/**
 * 카테고리 전시 순서를 변경하는 mutation hook
 * @param setIsEditable
 * @param form
 * @return {{editCategoryExhibitOrder: UseMutationResult<unknown, unknown, void, unknown>}}
 */
const useCategoryExhibitOrderEdit = (setIsEditable, form) => {
  const queryClient = useQueryClient();
  const { search } = useLocation();
  const { success, error } = useToastMsg();

  const editCategoryExhibitOrder = useMutation({
    mutationFn: (data) => CategoryApi.editCategoryExhibitOrder(data),
    onSuccess: async () => {
      const result = await CategoryApi.getCategoryListTree(search);

      // 업데이트 된 카테고리 전시 리스트 쿼리 데이터로 설정
      queryClient.setQueryData([...CATEGORY.LIST_TREE], result);

      // 요청 성공 시, 편집 상태 닫기 및 검색 키워드 초기화 후 성공 토스트 메세지 노출
      setIsEditable(false);
      form.setFieldsValue({ 'category-search-keyword': null });
      success(categoryToastMsg.EDIT_CATEGORY_EXHIBIT_ORDER_SUCCESS);
    },
    onError: (e) => {
      console.error(e);
      error(categoryToastMsg.CATEGORY_EXHIBIT_MAX_SIZE_ERROR, e);
    },
  });

  return { editCategoryExhibitOrder };
};

export default useCategoryExhibitOrderEdit;
